/* eslint-disable */
import {
  login,
  logout,
  getInfo,
  updateProfileAdminStored,
  updatePasswordAdminStored,
  checkSubdomain,
  loginStored,
  registasiStroed,
  updateProfile
} from "@/api/user";
import { loginMulti, checkSubdomainMulti } from "@/api/userMulti";
import {
  getToken,
  setToken,
  removeToken,
  getSubdomain,
  setSubdomain,
  removeSubdomain,
  removeMultiAccount,
  setMultiAccount,
  getMultiAccount,
  getApplicationType
} from "@/utils/auth";
import router, { resetRouter } from "@/router";
import store from "@/store";

const state = {
  subdomain: getSubdomain(),
  token: getToken(),
  name: "",
  avatar: "",
  introduction: "",
  roles: [],
  app_detail: [],
  profileArr: [],
  multiAccount: getMultiAccount(),
  member_type: ""
};

const mutations = {
  SET_MULTI_ACCOUNT: (state, accountArr) => {
    state.multiAccount = accountArr;
  },
  SET_SUBDOMAIN: (state, subdomain) => {
    state.subdomain = subdomain;
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_APP_DETAIL: (state, details) => {
    state.app_detail = details;
  },
  SET_profileArr: (state, details) => {
    state.profileArr = details;
  },
  SET_member_type: (state, member_type) => {
    state.member_type = member_type;
  }
};

const actions = {
  loginStored({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      loginStored(userInfo)
        .then(response => {
          const { data } = response;
          commit("SET_TOKEN", data.token);
          setToken(data.token);
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateProfile({ commit }, dataParams) {
    return new Promise((resolve, reject) => {
      updateProfile(dataParams)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token)
        .then(response => {
          const { data } = response;
          if (!data) {
            reject("Verification failed, please Login again.");
          }
          const { roles, name, avatar, introduction, app_detail } = data;
          if (!roles || roles.length <= 0) {
            reject("getInfo: roles must be a non-null array!");
          }
          commit("SET_ROLES", roles);
          commit("SET_member_type", data.member_type);
          commit("SET_profileArr", data);
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  logoutAll({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          commit("SET_SUBDOMAIN", "");
          commit("SET_TOKEN", "");
          commit("SET_ROLES", []);
          commit("SET_APP_DETAIL", []);
          commit("SET_NAME", "");
          commit("SET_MULTI_ACCOUNT", []);
          removeToken();
          resetRouter();
          removeSubdomain();
          removeMultiAccount();
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  registrasi({ commit }, data) {
    console.log("isi data registrasi", data);
    return new Promise((resolve, reject) => {
      registasiStroed(data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  forgot({ commit }, data) {
    console.log("isi data lupa password", data);
    return new Promise((resolve, reject) => {
      forgotStroed(data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // end progresss

  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          commit("SET_SUBDOMAIN", "");
          commit("SET_TOKEN", "");
          commit("SET_ROLES", []);
          commit("SET_APP_DETAIL", []);
          commit("SET_NAME", "");
          removeToken();
          resetRouter();
          removeSubdomain();
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // user update
  updateProfileAdminStored({ commit }, dataResponse) {
    // const { admin_username, admin_name } = dataResponse
    return new Promise((resolve, reject) => {
      updateProfileAdminStored(dataResponse)
        .then(response => {
          // const { data } = response
          // console.log('data: ',data)
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // user update password
  updatePasswordAdminStored({ commit }, dataResponse) {
    // const { admin_username, admin_name } = dataResponse
    return new Promise((resolve, reject) => {
      updatePasswordAdminStored(dataResponse)
        .then(response => {
          // const { data } = response
          // console.log('data: ',data)
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // user login
  async checkSubdomain({ commit }, userInfo) {
    // console.log('subdomain: ',subdomain)
    const { subdomain } = userInfo;
    setSubdomain("-");
    return new Promise((resolve, reject) => {
      checkSubdomain({ subdomain: subdomain })
        .then(response => {
          // alert('subdomain:::'+subdomain)
          // setSubdomain(subdomain)
          // console.log('responseSubdomain', response)
          // const { data } = response
          // setSubdomain(data.subdomain)
          resolve(response);
        })
        .catch(error => {
          // alert('checkSubdomain: ', error)
          reject(error);
        });
    });
  },

  // async login({ commit }, userInfo) {
  //   const { username, password} = userInfo
  //   return new Promise((resolve, reject) => {
  //     login({ username: username.trim(), password: password }).then(response => {
  //       console.log('response', response)
  //       const { data } =  response
  //       commit('SET_TOKEN', data.token)
  //       commit('SET_SUBDOMAIN', getSubdomain())
  //       setToken(data.token)
  //       resolve(response)
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },

  // user login multi account
  loginMulti({ commit }, userInfo) {
    const { username, password } = userInfo;
    return new Promise((resolve, reject) => {
      store.dispatch("monitoring/setSwitchAccount", 1);
      loginMulti({ username: username.trim(), password: password })
        .then(response => {
          console.log("response", response);
          // const { data } = response
          // commit('SET_TOKEN', data.token)
          // setToken(data.token)

          //update multi account
          //  var subdomainName=getSubdomain()
          //  this.$store.dispatch("user/pushMultiLoginAccount", subdomainName, this.loginForm.username, this.loginForm.password)
          //  this.pushMultiLoginAccount(subdomain,username,password)
          store.dispatch("monitoring/setSwitchAccount", 0);

          resolve(response);
        })
        .catch(error => {
          store.dispatch("monitoring/setSwitchAccount", 0);
          reject(error);
          // console.log('error coy', error)
        });
    });
  },

  // set subdomain multi login
  async checkSubdomainMulti({ commit }, userInfo) {
    // console.log('subdomain: ',subdomain)
    const { subdomain } = userInfo;
    return new Promise((resolve, reject) => {
      store.dispatch("monitoring/setSwitchAccount", 1);
      checkSubdomainMulti({ subdomain: subdomain })
        .then(response => {
          // alert('subdomain:::'+subdomain)
          // setSubdomain(subdomain)
          // console.log('responseSubdomain', response)
          // const { data } = response
          // setSubdomain(data.subdomain)
          store.dispatch("monitoring/setSwitchAccount", 0);

          resolve(response);
        })
        .catch(error => {
          // alert('checkSubdomain: ', error)
          store.dispatch("monitoring/setSwitchAccount", 0);

          reject(error);
        });
    });
  },

  // get user info

  // user logout

  // user logout

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit("SET_TOKEN", "");
      commit("SET_ROLES", []);
      commit("SET_APP_DETAIL", []);
      commit("SET_NAME", "");
      removeToken();
      resolve();
    });
  },
  /**
   * pushMultiLoginAccount
   * fungsi untuk push array multi account
   * @param {*} param0
   * @param string infoArr
   */
  pushSingleLoginAccount({ commit, state }, infoArr) {
    commit("SET_MULTI_ACCOUNT", []);
    removeMultiAccount();

    // return new Promise(resolve => {
    const listMultiAccount = state.multiAccount;
    // const listMultiAccount = []
    var isSubdomainExist = false;
    if (listMultiAccount.length > 0) {
      isSubdomainExist = true;
      listMultiAccount.forEach(rowArr => {
        // const tmp = { ...rowArr }
        if (rowArr.subdomain != infoArr.subdomain) {
          isSubdomainExist = false;
        }
      });
    }

    var currentSubdomainLogin = state.subdomain;
    if (
      isSubdomainExist == false &&
      currentSubdomainLogin != infoArr.subdomain
    ) {
      var item = {
        subdomain: infoArr.subdomain,
        subdomain_name: infoArr.subdomain_name,
        username: infoArr.username,
        password: infoArr.password,
        token: infoArr.token,
        data: []
      };
      listMultiAccount.push(item);
      // console.log("item",item)
    } else if (currentSubdomainLogin == infoArr.subdomain) {
      var item = {
        subdomain: currentSubdomainLogin,
        subdomain_name: infoArr.subdomain_name,
        username: "",
        password: "",
        token: state.token,
        data: []
      };
      listMultiAccount.push(item);
    }
    commit("SET_MULTI_ACCOUNT", listMultiAccount);
    setMultiAccount(listMultiAccount);
    // resolve()
    // console.log("mulit account commit")
    // console.log("listMultiAccount",listMultiAccount)
    // })
  },
  /**
   * pushMultiLoginAccount
   * fungsi untuk push array multi account
   * @param {*} param0
   * @param string infoArr
   */
  async pushMultiLoginAccount({ commit, state }, infoArr) {
    // return new Promise(resolve => {
    var applicationType =
      getApplicationType() == "OFFLINE" ? "inofarma_" : "inofarmapos_";
    var listMultiAccount = state.multiAccount;
    if (!(listMultiAccount instanceof Array)) {
      listMultiAccount = [];
    }
    console.log("state.multiAccount", state.multiAccount);
    console.log("storage.multiAccount", getMultiAccount());
    // const listMultiAccount = []
    var isSubdomainExist = false;
    if (listMultiAccount.length > 0) {
      var index = 0;
      listMultiAccount.forEach(rowArr => {
        //jika data token dan subdomain ditemukan maka hapus data utk persiapan update
        if (rowArr.subdomain == infoArr.subdomain) {
          infoArr.token =
            infoArr.token == "" && rowArr.token != ""
              ? rowArr.token
              : infoArr.token;
          isSubdomainExist = true;
          listMultiAccount.splice(index, 1);
        }
        index++;
      });
    }

    var currentSubdomainLogin = state.subdomain;
    // console.log("currentSubdomainLogin: ",currentSubdomainLogin,"infoArr.subdomain",infoArr.subdomain)
    // console.log("isSubdomainExist: ",isSubdomainExist)
    // console.log("listMultiAccount1::::",listMultiAccount)

    if (isSubdomainExist == true) {
      var item = {
        subdomain: infoArr.subdomain,
        subdomain_name: infoArr.subdomain.replace(applicationType, ""),
        username: "",
        password: "",
        token: infoArr.token,
        data: []
      };
      listMultiAccount.push(item);
    } else if (
      (isSubdomainExist == false || listMultiAccount.length == 0) &&
      currentSubdomainLogin != infoArr.subdomain
    ) {
      var item = {
        subdomain: infoArr.subdomain,
        subdomain_name: infoArr.subdomain_name,
        username: infoArr.username,
        password: infoArr.password,
        token: infoArr.token,
        data: []
      };
      listMultiAccount.push(item);
    } else if (currentSubdomainLogin == infoArr.subdomain) {
      var item = {
        subdomain: currentSubdomainLogin,
        subdomain_name: infoArr.subdomain_name,
        username: "",
        password: "",
        token: state.token,
        data: []
      };
      listMultiAccount.push(item);
    }
    commit("SET_MULTI_ACCOUNT", listMultiAccount);
    // console.log('setmulti account token:;',listMultiAccount)
    await setMultiAccount(listMultiAccount);
    // console.log("storage.multiAccount",getMultiAccount())
  },
  /**
   * removehMultiLoginAccount
   * fungsi untuk push array multi account
   * @param {*} param0
   * @param string infoArr
   */
  removeMultiLoginAccount({ commit, state }, infoArr) {
    // return new Promise(resolve => {
    const listMultiAccount = state.multiAccount;
    // const listMultiAccount = []
    if (listMultiAccount.length > 0) {
      var index = 0;
      listMultiAccount.forEach(rowArr => {
        //jika data token dan subdomain ditemukan maka hapus data utk persiapan update
        if (rowArr.subdomain == infoArr.subdomain) {
          infoArr.token =
            infoArr.token == "" && rowArr.token != ""
              ? rowArr.token
              : infoArr.token;
          listMultiAccount.splice(index, 1);
        }
        index++;
      });

      commit("SET_MULTI_ACCOUNT", listMultiAccount);
      setMultiAccount(listMultiAccount);
    }
  },
  async updateDataMultiLoginAccount({ commit, state }, infoArr) {
    await setMultiAccount(infoArr);
    commit("SET_MULTI_ACCOUNT", infoArr);
    console.log("storage.multiAccount.infoArr", infoArr);
    console.log("storage.multiAccount.infoArrget", getMultiAccount());
  },
  async switchLoginAccount({ commit, state }, infoArr) {
    commit("SET_SUBDOMAIN", infoArr.subdomain);
    commit("SET_TOKEN", infoArr.token);
    await setToken(infoArr.token);
    await setSubdomain(infoArr.subdomain);
    await store.dispatch("user/getInfo");
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js